import { Utilities as utilities, IUserInfo } from "@truckdown/framework";
import { ClaimsModel } from "./ClaimsModel";

export class LoginResult {
    constructor(json?: any) {
        if (json) {
            this.isAuthenticated = utilities.json.getBooleanValue(json, 'ia', false);
            this.scheme = utilities.json.getStringValue(json, 'scheme', '');

            this.userInfo = utilities.json.getObjectValue<IUserInfo | null>(json, (data) => {
                if (!data || data == null) {
                    return null;
                }
                return data as IUserInfo;
            }, "user_info", null);

            this.claims = utilities.json.getArrayValue<ClaimsModel>(json, (data) => {
                if (!data || data === null) {
                    return null;
                }
                return new ClaimsModel(data);
            }, 'claims', []);

            this.settings = utilities.json.getObjectValue<{ [key: string]: string; }>(json, (data) => {
                if (!data || data === null) {
                    return {};
                }
                return data as { [key: string]: string; };
            }, 'settings', {});

            this.message = utilities.json.getStringValue(json, 'msg', '');
            this.authToken = utilities.json.getStringValue(json, 'auth', '');
            this.tokenKey = utilities.json.getStringValue(json, 'tkey', '');
            this.apiKey = utilities.json.getStringValue(json, 'api', '');
        }
    }

    isAuthenticated: boolean = false;
    scheme: string = '';
    userInfo: IUserInfo | null = null;
    claims: ClaimsModel[] = [];
    settings: { [key: string]: string; } = {};
    message: string = '';
    authToken: string = '';
    tokenKey: string = '';
    apiKey: string = '';
}